import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Dropdown } from "components";
import { ApiErrors, Billing } from "modules/ExactMonitoring/components";
import "modules/ExactMonitoring/ExactMonitoring.scss";

enum EXACT_MONITORING_PAGES {
  ApiErrors = 1,
  Billing
}

export const ExactMonitoring = () => {
  const { t } = useTranslation();

  const [showApiErrorsPage, setShowApiErrorsPage] = useState(true);

  return (
    <div className="ExactMonitoring">
      <div className="page-selection-container">
        <Dropdown
          placeholder={t("v8_select_page", "Select Page")}
          options={[
            { key: EXACT_MONITORING_PAGES.ApiErrors, value: EXACT_MONITORING_PAGES.ApiErrors, text: t("v8_api_errors", "API Errors") },
            { key: EXACT_MONITORING_PAGES.Billing, value: EXACT_MONITORING_PAGES.Billing, text: t("v8_billing", "Billing") }
          ]}
          selection
          selectOnBlur={false}
          onChange={monitoringPage => setShowApiErrorsPage(monitoringPage === EXACT_MONITORING_PAGES.ApiErrors)}
          defaultValue={EXACT_MONITORING_PAGES.ApiErrors}
        />
      </div>
      {showApiErrorsPage ? <ApiErrors /> : <Billing />}
    </div>
  );
};
